module.exports = __webpack_public_path__ + "img/IconsetW_1x.7b1ef418.png";